'use strict';

/* eslint-disable no-mixed-spaces-and-tabs */
angular.module('upsalesApp').run([
	'AccountRelation',
	'LatestAccountsService',
	'StandardIntegration',
	'NotificationService',
	'UserTreeFilterMeta',
	'MultiRunnerActions',
	'GroupMailCategory',
	'PushNotifications',
	'currenciesISO4217',
	'ActionProperties',
	'LANDINGPAGEPATH',
	'SoliditetClient',
	'STATIC_MAPS_KEY',
	'ListViewService',
	'ListAttributes',
	'RequestBuilder',
	'browserService',
	'FeatureHelper',
	'avatarService',
	'localeService',
	'ScriptService',
	'CountryCodes',
	'MailCampaign',
	'$stateParams',
	'FilterHelper',
	'$multiSelect',
	'MailAccount',
	'Appointment',
	'$datepicker',
	'LEAD_SOURCE',
	'Opportunity',
	'TagsService',
	'DisplayType',
	'FilterType',
	'AppService',
	'TagService',
	'ClientForm',
	'$translate',
	'$rootScope',
	'LeaderPage',
	'Onboarding',
	'$location',
	'$injector',
	'Agreement',
	'$upModal',
	'Campaign',
	'ListView',
	'Activity',
	'$cookies',
	'SniCodes',
	'EditorCk',
	'Session',
	'Product',
	'Account',
	'Segment',
	'Contact',
	'$filter',
	'Lookup',
	'$state',
	'Report',
	'Import',
	'OptIn',
	'Esign',
	'Order',
	'Event',
	'utils',
	'Lead2',
	'$http',
	'Links',
	'Self',
	'Mail',
	'Flow',
	'Form',
	'File',
	'$sce',
	'URL',
	'Ads',
	'API',
	'ENV',
	'$q',
	'ReportView',
	'ContactRelation',
	'LeadSource',
	'AgreementSettings',
	function (
		AccountRelation,
		LatestAccountsService,
		StandardIntegration,
		NotificationService,
		UserTreeFilterMeta,
		MultiRunnerActions,
		GroupMailCategory,
		PushNotifications,
		currenciesISO4217,
		ActionProperties,
		LANDINGPAGEPATH,
		SoliditetClient,
		STATIC_MAPS_KEY,
		ListViewService,
		ListAttributes,
		RequestBuilder,
		browserService,
		FeatureHelper,
		avatarService,
		localeService,
		ScriptService,
		CountryCodes,
		MailCampaign,
		$stateParams,
		FilterHelper,
		$multiSelect,
		MailAccount,
		Appointment,
		$datepicker,
		LEAD_SOURCE,
		Opportunity,
		TagsService,
		DisplayType,
		FilterType,
		AppService,
		TagService,
		ClientForm,
		$translate,
		$rootScope,
		LeaderPage,
		Onboarding,
		$location,
		$injector,
		Agreement,
		$upModal,
		Campaign,
		ListView,
		Activity,
		$cookies,
		SniCodes,
		EditorCk,
		Session,
		Product,
		Account,
		Segment,
		Contact,
		$filter,
		Lookup,
		$state,
		Report,
		Import,
		OptIn,
		Esign,
		Order,
		Event,
		utils,
		Lead2,
		$http,
		Links,
		Self,
		Mail,
		Flow,
		Form,
		File,
		$sce,
		URL,
		Ads,
		API,
		ENV,
		$q,
		ReportView,
		ContactRelation,
		LeadSource,
		AgreementSettings
	) {
		/* eslint-enable no-mixed-spaces-and-tabs */

		// Services
		// Tools.AccountRelation is gone (WEB-11246) — React imports App/resources/AccountRelation
		// directly (WEB-11176). Its DI param stays for positional-injection safety, same as
		// AppService below.
		window.Tools.$multiSelect = $multiSelect;
		window.Tools.NotificationService = NotificationService;
		window.Tools.MultiRunnerActions = MultiRunnerActions;
		window.Tools.currenciesISO4217 = currenciesISO4217;
		window.Tools.SoliditetClient = SoliditetClient;
		window.Tools.RequestBuilder = RequestBuilder;
		// Tools.browserService is gone (WEB-11184) — React imports Services/BrowserService directly.
		// The DI param stays for positional-injection safety, same as AppService above.
		window.Tools.FeatureHelper = FeatureHelper;
		window.Tools.avatarService = avatarService;
		window.Tools.$stateParams = $stateParams;
		window.Tools.FilterHelper = FilterHelper;
		// Tools.FilterType is gone (WEB-11246) — it had no readers left. Its DI param stays for
		// positional-injection safety, same as AppService below.
		window.Tools.TagsService = TagsService;
		window.Tools.Appointment = Appointment;
		window.Tools.$datepicker = $datepicker;
		window.Tools.DisplayType = DisplayType;
		window.Tools.$rootScope = $rootScope;
		// Tools.LeaderPage is gone (WEB-11308) — both React callers use App/babel/resources/LeaderPage.
		// The DI param stays: the Angular LeaderPage resource is still injected by name in
		// attributes/visitor.js, and the positional arrays here must not shift.
		// Tools.AppService is installed by the ToolsShim (WEB-8009) — the standalone owns it now.
		// The AppService DI param stays: tools.js is deleted wholesale in WEB-7616, and touching
		// the positional injection arrays here would risk shifting every other service.
		window.Tools.TagService = TagService;
		window.Tools.$translate = $translate.instant;
		window.Tools.$location = $location;
		window.Tools.$injector = $injector;
		window.Tools.$upModal = $upModal;
		window.Tools.$filter = $filter;
		window.Tools.$state = $state;
		window.Tools.$q = $q;
		// Tools.$sce and Tools.$http are gone (WEB-11246) — they had no readers left. Their DI
		// params stay for positional-injection safety, same as AppService above.
		window.Tools.Onboarding = Onboarding;
		window.Tools.PushNotifications = PushNotifications;
		// Tools.CountryCodes is installed by the ToolsShim (WEB-7777) — the standalone owns it now.
		// The CountryCodes DI param stays for positional-injection safety, same as AppService above.
		// Tools.LEAD_SOURCE is gone (WEB-10798) — React imports App/enum/leadSource directly. Its DI
		// param stays for the same positional-injection reason.
		window.Tools.localeService = localeService;
		window.Tools.ListAttributes = ListAttributes;
		window.Tools.LatestAccountsService = LatestAccountsService;
		window.Tools.ScriptService = ScriptService;
		// Tools.$cookies is gone (WEB-11246) — it had no readers left. Its DI param stays for
		// positional-injection safety, same as AppService above.
		window.Tools.EditorCk = EditorCk;
		window.Tools.utils = utils;
		window.Tools.ListViewService = ListViewService;
		// Tools.Session and Tools.Self are gone (WEB-11246) — they had no readers left. Their DI
		// params stay for positional-injection safety, same as AppService above.

		// Resources
		window.Tools.Agreement = Agreement;
		window.Tools.MailCampaign = MailCampaign;
		window.Tools.Activity = Activity;
		window.Tools.Campaign = Campaign;
		window.Tools.Product = Product;
		window.Tools.Account = Account;
		window.Tools.Contact = Contact;
		window.Tools.ListView = ListView;
		window.Tools.OptIn = OptIn;
		// Tools.Segment is gone (WEB-11189) — React imports App/resources/Segment directly. The Segment
		// DI param stays for positional-injection safety, same as AppService above; the Angular Segment
		// factory is still registered and still injected by name elsewhere.
		window.Tools.Mail = Mail;
		window.Tools.Flow = Flow;
		window.Tools.Report = Report;
		window.Tools.Import = Import;
		window.Tools.Form = Form;
		window.Tools.File = File;
		window.Tools.Esign = Esign;
		window.Tools.Event = Event;
		// Tools.FormSubmit is gone (WEB-11281) — App/resources/FormSubmit owns it now. The Angular
		// factory stays, since formSubmit.js, editSegment.js and viewSubmit.js still inject it by DI;
		// only this global goes. Nothing here reads it any more, so the DI param was dropped from the
		// annotation array and the signature together, keeping the positions aligned.
		window.Tools.Ads = Ads;
		window.Tools.Lead2 = Lead2;
		window.Tools.Order = Order;
		// Tools.Lookup is gone (WEB-11083) — React imports App/resources/Lookup directly. The Lookup DI
		// param stays for positional-injection safety, same as AppService above; the Angular Lookup
		// factory is still registered and still injected by name elsewhere.
		window.Tools.StandardIntegration = StandardIntegration;
		window.Tools.Opportunity = Opportunity;
		// Tools.SniCodes is gone (WEB-10913), Tools.GroupMailCategory is gone (WEB-10966) and
		// Tools.Links is gone (WEB-11045) — React imports App/enum/sniCodes,
		// App/resources/GroupMailCategory and App/resources/Links directly. Their DI params stay for
		// positional-injection safety, same as AppService above — those Angular providers are still
		// registered. When the provider itself is deleted the DI param must go too, or Angular throws
		// Unknown provider at boot; that is what WEB-11021 did for MailCampaignInfo and WEB-11025 did
		// for AllIWant.
		// Tools.ClientForm is gone (WEB-11139) — App/resources/ClientForm owns it now. The DI param
		// stays for positional-injection safety, same as AppService above — the Angular factory is
		// still registered and soliditet.js still injects it by name.
		window.Tools.MailAccount = MailAccount;
		// LeadSource is no longer installed on Tools (WEB-10528) — Resources/LeadSource owns it now.
		// The LeadSource DI param stays for positional-injection safety, same as AppService above.
		// Tools.ActivityList is gone (WEB-11255) — App/resources/ActivityList owns it now. The Angular
		// factory stays, since six controllers and editOrder still inject it by DI; only this global
		// goes. Nothing here reads it any more, so the DI param was dropped from the annotation array
		// and the signature together, keeping the positions aligned.
		window.Tools.ReportView = ReportView;
		window.Tools.ContactRelation = ContactRelation;
		window.Tools.AgreementSettings = AgreementSettings;
		// Tools.DocumentTemplate is gone (WEB-11177) — App/resources/DocumentTemplate owns it now; the
		// Angular factory is deleted so the DI param goes with it.

		window.Tools.URL = URL;
		window.Tools.API = API;
		window.Tools.LANDINGPAGEPATH = LANDINGPAGEPATH;
		window.Tools.STATIC_MAPS_KEY = STATIC_MAPS_KEY;
		window.Tools.ENV = ENV;
	}
]);
